import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'merge',
  name: 'Merge',
  category: 'flow-control',
  description: 'Merge multiple execution paths into one',
  icon: 'GitMerge',
  color: 'amber',
  version: '1.0.0',
  comingSoon: false,
  inputs: [
    {
      name: 'input1',
      type: 'main',
      displayName: 'Input 1',
      required: true,
    },
    {
      name: 'input2',
      type: 'main',
      displayName: 'Input 2',
      required: true,
    },
    {
      name: 'input3',
      type: 'main',
      displayName: 'Input 3',
      required: false,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
